import Styles from "../../css/landing_css/l_header_d.module.css";
import MypageIcon from "../../assets/landing_assets/l_myPage_icon.svg";
import AlertIcon from "../../assets/landing_assets/l_alert_icon.svg";

function Lheader() {
    return (
        <div className={Styles.scaffold}>
            <div className={Styles.f20w700white}>뚝딱이</div>
            {/* <div style={{ display: "flex", alignItems: "center" }}>
                <img src={AlertIcon} />
                <div style={{ width: "16px" }} />
                <img src={MypageIcon} />
            </div> */}
        </div>
    );

};

export default Lheader;
